import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ProfileComponent } from '@app/profile/profile.component';
import { StepperModule } from '@app/shared/stepper/stepper.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProfileComponent],
  imports: [CommonModule, StepperModule, TranslateModule, MatFormFieldModule, MatSelectModule, MatButtonModule],
  exports: [ProfileComponent],
})
export class ProfileModule {}
